import { NavLink } from "react-router-dom";
import "./Side.css";
import {
  PlusSquare,
  ShoppingCart,
  CheckSquare,
  UserPlus,
  Truck,
  Boxes,
  BarChart3,
  Settings,
} from "lucide-react";

export default function Sidebar({ isOpen }) {
  const role = localStorage.getItem("user_role"); // FIXED KEY

  const isAdmin = role === "admin" || role === "superadmin";
  const isSales = role === "sales";

  return (
    <aside className={`admin-sidebar ${isOpen ? "open" : ""}`}>
      <nav>
        {/* ✅ Visible for BOTH admin & sales */}
        <NavLink to="/admin/dashboard">
          <PlusSquare size={18} />
          <span>product create</span>
        </NavLink>

      

        {/* ✅ Visible for BOTH admin & sales */}
        <NavLink to="/admin/orders">
          <ShoppingCart size={18} />
          <span>All Orders</span>
        </NavLink>

         {/* ✅ Visible for BOTH admin & sales */}
        <NavLink to="/admin/products">
          <CheckSquare size={18} />
          <span>Approved Order</span>
        </NavLink>
        
          <NavLink to="/admin/AdminProducts">
            <Boxes size={18} />
            <span>All Products</span>
          </NavLink>
        

        {/* ❌ Hidden for sales */}
        {isAdmin && (
          <NavLink to="/admin/users">
            <UserPlus size={18} />
            <span>create Sales</span>
          </NavLink>
        )}

        {/* ❌ Hidden for sales */}
        {isAdmin && (
          <NavLink to="/admin/notifications">
            <Truck size={18} />
            <span>DeliveredOrders</span>
          </NavLink>
        )}

      

        {/* ❌ Hidden for sales */}
        {isAdmin && (
          <NavLink to="/admin/reports">
            <BarChart3 size={18} />
            <span>Reports</span>
          </NavLink>
        )}

      
          <NavLink to="/admin/settings">
            <Settings size={18} />
            <span>Settings</span>
          </NavLink>
       
      </nav>
    </aside>
  );
}
